import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";

const ChangeEmailDialog = ({
  open,
  onClose,
  currentEmail,
  onSendOtp,
  isLoading = false,
  errorMessage,
}) => {
  const [email, setEmail] = useState(currentEmail || "");
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    if (open) {
      setEmail(currentEmail || "");
      setLocalError("");
    }
  }, [open, currentEmail]);

  const handleClose = () => {
    setEmail(currentEmail || "");
    setLocalError("");
    onClose();
  };

  const handleSendOtp = () => {
    setLocalError("");
    if (!email || !email.trim()) {
      setLocalError("Email is required");
      return;
    }
    // Basic email validation
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(email.trim())) {
      setLocalError("Invalid email address");
      return;
    }
    onSendOtp(email.trim());
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      sx={{
        zIndex: 1500,
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          change email
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="email"
            placeholder="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setLocalError("");
            }}
            error={!!errorMessage || !!localError}
            helperText={errorMessage || localError}
            disabled={isLoading}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
            InputProps={{
              sx: { fontSize: "1em" },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleSendOtp}
            disabled={isLoading || !email.trim()}
            sx={{
              py: 1.5,
              borderRadius: 2,
              fontWeight: 600,
              fontSize: "1em",
              bgcolor: "#6200EE",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#761afc",
              },
            }}
            endIcon={<SendIcon />}
          >
            {isLoading ? "sending..." : "send otp"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeEmailDialog;

